const FILTER_CHANGED = 'FILTER_CHANGED'

const events = [
    FILTER_CHANGED
]

const initializeEventListeners = () => {
    EVENT_BUS.registerEvents(events);
}

export const GRID_VIEW_FILTERS_EVENTS = {
    initializeEventListeners,
    FILTER_CHANGED
}
